import Vue from "vue";
import App from "./App";
import router from "./router/index";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import PaperDashboard from "./plugins/paperDashboard";
import "vue-notifyjs/themes/default.css";
import VueI18n from "vue-i18n";

// Toast ayarları
const toastOptions = {
  transition: "Vue-Toastification__fade",
  position: "top-right",
  timeout: 2000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false
};

Vue.use(Toast, toastOptions);
Vue.use(PaperDashboard);
Vue.use(VueI18n);

// Çevirileri libs klasöründen yükle
import en from "./libs/i18n/locales/en.json";
import tr from "./libs/i18n/locales/tr.json";
import de from "./libs/i18n/locales/de.json";

// i18n yapılandırması
const i18n = new VueI18n({
  locale: "tr", // Varsayılan dil
  fallbackLocale: "en", // Yedek dil (çeviri bulunmazsa kullanılacak)
  messages: {
    en: en,
    tr: tr,
    de: de
  }
});

/* eslint-disable no-new */
new Vue({
  router,
  i18n, // i18n'i Vue örneğine ekleyin
  render: (h) => h(App),
}).$mount("#app");
